export default {"src":"/_next/static/media/private-cloud-white.9b5e0a23.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};